export const company_profile_page = {
  title: "Company Profile",
  back_to_account_aria: "Back to account",
};
